// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branding-hierarchy-menu-container {
  display: flex;
  flex-direction: column;
  width: 480px;
  max-height: 480px;
  background: white;
  padding: 16px 16px 0 16px;
  box-shadow: 0px 0px 16px 0px #00000033;
  overflow-x: hidden;
  overflow-y: auto;
}
.branding-hierarchy-menu-container .nkl-menu {
  margin: 16px -16px 0 -16px;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
